import api from '../../utils/api/api';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { API_ADMIN_VALID_EVENTS_URI } from '../../utils/api/constants';

export const useValidateEvents = (): UseMutationResult<void, Error, string[], unknown> => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string[]>(ids => api.post(API_ADMIN_VALID_EVENTS_URI, { ids }).then(res => res.data), {
    onSuccess: () => {
      queryClient.refetchQueries('invalidEvents');
      queryClient.refetchQueries('events');
    },
  });
};
